var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order"},[_c('div',{staticClass:"orderTitle"},[_c('orderTitle')],1),_c('div',{staticClass:"orderMain"},[_c('div',{staticClass:"leftNav"},[_c('orderMenu')],1),_c('div',{staticClass:"view"},[_c('SelectedMenu')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }